import { render, staticRenderFns } from "./HandleModal.vue?vue&type=template&id=4ed26d6c&scoped=true"
import script from "./HandleModal.vue?vue&type=script&lang=js"
export * from "./HandleModal.vue?vue&type=script&lang=js"
import style0 from "./HandleModal.vue?vue&type=style&index=0&id=4ed26d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed26d6c",
  null
  
)

export default component.exports